import { useEffect, useState } from 'react';
import { useSetting } from '../../../util/useSetting';
import DropDownSelection from './DropDownSelection';

export default function VerticalDragableList(props) {
    const [draggedIndex, setDraggedIndex] = useState(null);
    const [list, setList] = useState(props.lists || []);
    const { fontSize } = useSetting();

    useEffect(() => {
        setList(props.lists || []);
    }, [props.lists]);

    const updateList = (newList) => {
        setList(newList);
        if (props.onUpdate) {
            props.onUpdate(newList);
        }
    };

    const handleDrop = (dropIndex) => {
        if (draggedIndex === null || draggedIndex === dropIndex) {
            setDraggedIndex(null);
            return;
        }

        const newList = [...list];
        const [draggedItem] = newList.splice(draggedIndex, 1);
        newList.splice(dropIndex, 0, draggedItem);
        updateList(newList);
        setDraggedIndex(null);
    };
    const handleToggleEdit = (index) => {
        const newList = [...list];
        newList[index].isEditing = !newList[index].isEditing;
        updateList(newList);
    };
    const handleDelete = (index) => {
        const newList = [...list];
        newList.splice(index, 1);
        updateList(newList);
    };
    const handleCancel = (index) => {
        const newList = [...list];
        newList[index].isEditing = false;
        updateList(newList);
    };
    const handleToggleSelect = (index) => {
        const newList = [...list];
        newList[index].selected = !newList[index].selected;
        updateList(newList);
    };

    return (
        <div className='flex flex-col w-full h-full overflow-auto gap-[4px] font-bold' style={{ fontSize }}>
            {list.map((item, index) => (
                item?.isEditing ?
                    <div key={index} className='flex flex-col w-full bg-[#E1E1E1] rounded-[8px]'>
                        <div
                            className='flex flex-row items-start justify-between p-[8px]' style={{ border: '1px solid #ccc', borderRadius: '8px' }}
                            onDragOver={(event) => event.preventDefault()}
                            onDrop={() => handleDrop(index)}
                        >
                            {/*drag handle*/}
                            <div
                                className='cursor-move'
                                draggable
                                onDragStart={() => setDraggedIndex(index)}
                                onDragEnd={() => setDraggedIndex(null)}
                            >
                                ☰
                            </div>
                            <div className='flex flex-col w-full'>
                                <div className='flex flex-row flex-1 items-start gap-[4px] ml-[8px]'>
                                    <div className='flex flex-col items-cente gap-[4px]'>
                                        <DropDownSelection value={item?.type || ''} options={['選擇題', '短答題']} onUpdate={(newValue) => { const newList = [...list]; newList[index].type = newValue; updateList(newList); }} />
                                        <DropDownSelection value={item?.ability_point || '能力點'} options={[
                                            '1.2 跨來源搜索、導航與篩選',
                                            '1.1 獲取並提取文本內信息',
                                            '2.2 生成推斷',
                                            '2.1 建構文本字面意義',
                                            '2.4 整合跨文本信息',
                                            '2.3 整合文本內信息',
                                            '3.2 反思內容與形式',
                                            '3.1 評估質量與真實性',
                                            '3.3 發現並處理衝突',
                                            '4.2 創造並傳達新意義',
                                            '4.1 將理解遷移至新情境'
                                        ]} onUpdate={(newValue) => { const newList = [...list]; newList[index].ability_point = newValue; updateList(newList); }} />
                                    </div>
                                    <div className='flex flex-col text-black flex-1 ml-[4px] bg-[#ffffffa0] p-[4px] rounded-[8px]' style={{ border: '1px solid white' }}>
                                        <textarea className='flex-1 px-[4px] rounded-[4px] bg-[transparent] min-h-[100px]' value={item?.question} onChange={(e) => { const newList = [...list]; newList[index].question = e.target.value; updateList(newList); }} />
                                        <div className='w-full flex flex-row justify-end'>
                                            <button className='flex flex-row items-center px-[12px] gap-[4px] text-white rounded-[99px]' style={{ background: 'linear-gradient(to right, #178E95, #07162F)' }}>
                                                <img src='/secondary/ai.png' className='w-[16px]' alt='AI生成' />
                                                AI生成
                                            </button>
                                        </div>
                                    </div>
                                    <button onClick={() => handleDelete(index)}>
                                        <img src='/secondary/delete.png' className='w-[16px]' alt='edit' />
                                    </button>
                                </div>
                                {item?.type === '選擇題' && (item?.options || []).map((option, optionIndex) => (
                                    <div key={optionIndex} className='flex flex-row items-center gap-[4px] mt-[6px] ml-[10px]'>
                                        <div className='flex flex-row items-center gap-[12px] w-[120px] justify-center'>
                                            [選擇 {optionIndex + 1}]
                                            <input type='checkbox' style={{ width: '16px', height: '16px' }} checked={option?.isSelected} onChange={(e) => {
                                                const newList = [...list];
                                                newList[index].options[optionIndex].isSelected = e.target.checked;
                                                updateList(newList);
                                            }} />
                                        </div>
                                        <input type='text' value={option?.option} style={{border:'1px solid white'}}onChange={(e) => {
                                            const newList = [...list];
                                            newList[index].options[optionIndex].option = e.target.value;
                                            updateList(newList);
                                        }} className='flex-1 py-[4px] rounded-[8px] bg-[#ffffff90] text-black px-[12px]' />
                                        <button onClick={() => {
                                            const newList = [...list];
                                            newList[index].options.splice(optionIndex, 1);
                                            updateList(newList);
                                        }}>
                                            <img src='/secondary/delete2.png' className='w-[16px]' alt='delete' />
                                        </button>
                                    </div>
                                ))}
                                <div className='flex flex-row items-center gap-[4px] justify-center mt-[4px]'>
                                    {item?.type === '選擇題' && (
                                        <button onClick={() => {
                                            const newList = [...list];
                                            newList[index].options = newList[index].options || [];
                                            newList[index].options.push({ option: '', isSelected: false });
                                            updateList(newList);
                                        }}>
                                            <img src='/secondary/add.png' className='w-[32px]' alt='add' />
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className='flex flex-row w-full bg-[#ffffff80] p-[16px] rounded-[8px]'>
                            <div className='text-[#a0a0a0] flex flex-row items-center gap-[4px]'>
                                <img src='/secondary/edit2.png' className='w-[16px]' alt='edit' />
                                編輯模式
                            </div>
                            <div className='flex flex-row items-center gap-[14px] flex-1 justify-center'>
                                <button className='bg-[#A9A9A9] text-white px-[36px] py-[4px] rounded-full' onClick={() => handleCancel(index)}>
                                    取消
                                </button>
                                <button className='bg-[#178E95] text-white px-[36px] py-[4px] rounded-full' onClick={() => handleCancel(index)}>
                                    儲存
                                </button>
                            </div>
                        </div>
                    </div>

                    : <div
                        key={index}
                        className='flex flex-row items-start justify-between p-[8px]' style={{ border: '1px solid #ccc', borderRadius: '8px' }}
                        onDragOver={(event) => event.preventDefault()}
                        onDrop={() => handleDrop(index)}
                    >
                        {/*drag handle*/}
                        <div
                            className='cursor-move'
                            draggable
                            onDragStart={() => setDraggedIndex(index)}
                            onDragEnd={() => setDraggedIndex(null)}
                        >
                            ☰
                        </div>
                        <div className='flex flex-row flex-1 items-start gap-[4px] ml-[8px]'>
                            <div className='flex flex-row items-center gap-[4px]'>
                                <input type='checkbox' checked={item?.selected || false} onChange={() => handleToggleSelect(index)} />
                                <div>[{item?.type || ''}]</div>
                            </div>
                            <div className='text-black flex-1'>{item?.question}</div>
                            <button onClick={() => handleToggleEdit(index)}>
                                <img src='/secondary/edit.png' className='w-[22px]' alt='edit' />
                            </button>
                        </div>
                    </div>
            ))}
        </div>
    );
}


